import { Navigate } from 'react-router-dom';

// Composant pour protéger les routes selon les sections autorisées du profil
function ProtectedSectionRoute({ user, requiredSection, children }) {
  // Si pas de sections définies, accès total (rétrocompatibilité)
  if (!user.sections || user.sections.length === 0) {
    return children;
  }

  // Vérifier si l'utilisateur a accès à cette section
  if (!user.sections.includes(requiredSection)) {
    // Rediriger vers la première section autorisée
    const firstSection = user.sections[0];
    const sectionPaths = {
      'profils': '/admin_4Sd6c3P7/profils',
      'operateurs': '/admin_4Sd6c3P7/operateurs',
      'produits': '/admin_4Sd6c3P7/produits',
      'codebarre': '/admin_4Sd6c3P7/codebarre',
      'production': '/admin_4Sd6c3P7/production',
      'planning': '/admin_4Sd6c3P7/planning',
      'revendeurs': '/admin_4Sd6c3P7/revendeurs',
      'ffm': '/admin_4Sd6c3P7/ffm',
      'stock': '/admin_4Sd6c3P7/stock'
    };
    
    return <Navigate to={sectionPaths[firstSection] || '/admin_4Sd6c3P7/production'} replace />;
  }

  return children;
}

export default ProtectedSectionRoute;
